/* ═══════════════════════════════════════════════════════════════════════════
   cart-quick-shop.js
   Behaviour for the empty-cart quick-shop module (snippets/cart-quick-shop.liquid).

   Loaded ONCE from theme.liquid so it survives the empty-cart drawer being
   re-injected via Shopify's AJAX Section Rendering (which happens when you
   remove the last line item). Inline <script> tags inside the injected markup
   never execute, so all behaviour must live here and use document-level
   delegation + a MutationObserver to (re)initialise whenever the module appears.
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var CFG = { t_no_results: 'No results for' };

  window.CQS_NavStack = window.CQS_NavStack || [];
  window.CQS_Brands = window.CQS_Brands || [];

  function cqsGoTo(handle) {
    if (!handle) return;
    window.location.href = '/collections/' + handle;
  }

  function cqsRenderModels(models, brandLabel) {
    var titleEl = document.getElementById('cqs-model-title');
    var gridEl = document.getElementById('cqs-grid-models');
    if (titleEl) titleEl.textContent = brandLabel;
    if (gridEl) {
      gridEl.innerHTML = models.map(function (m, i) {
        return '\
          <button type="button" class="cqs-card" data-model-idx="' + i + '">\
            <span>' + m.name + '</span>\
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>\
          </button>';
      }).join('');
    }
  }

  /* ── (Re)initialise: read data + build the brand grid. Idempotent. ── */
  /* The header's brand data, reshaped to this module's tree (2026-10-19): {b, h, m:[{t, u, s}]} becomes
     {id, label, allHandle, models:[{name, handle, kids}]}, with a model's series ("s") as its group. */
  function fromHeader() {
    var el = document.querySelector('script[id^="v2-brands-hdr-"]');
    var list = [];
    try { list = JSON.parse((el && el.textContent) || '[]'); } catch (e) { return []; }
    var hd = function (u) { return String(u || '').split('?')[0].split('/').filter(Boolean).pop() || ''; };
    return list.map(function (br) {
      var models = [], groups = {};
      (br.m || []).forEach(function (m) {
        var leaf = { name: m.t, handle: hd(m.u), kids: [] };
        if (m.s) {
          if (!groups[m.s]) { groups[m.s] = { name: m.s, handle: '', kids: [] }; models.push(groups[m.s]); }
          groups[m.s].kids.push(leaf);
        } else {
          models.push(leaf);
        }
      });
      var id = String(br.b || '').toLowerCase().replace(/\s+/g, '-');
      return { id: id, label: br.b, allHandle: br.h && br.h !== '#' ? hd(br.h) : '', models: models };
    });
  }

  function initCQS() {
    var cfgEl = document.getElementById('cqs-config');
    if (cfgEl) { try { CFG = JSON.parse(cfgEl.textContent) || CFG; } catch (e) {} }

    var dataEl = document.getElementById('cqs-data-source');
    var gridBrands = document.getElementById('cqs-grid-brands');
    if (!dataEl || !gridBrands) return;

    try {
      window.CQS_Brands = dataEl.hasAttribute('data-from-header') ? fromHeader() : JSON.parse(dataEl.textContent || '[]');
      window.CQS_NavStack = [];
      gridBrands.innerHTML = window.CQS_Brands.map(function (b, i) {
        return '\
          <button type="button" class="cqs-card" data-brand-idx="' + i + '">\
            <span>' + b.label + '</span>\
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>\
          </button>';
      }).join('');
    } catch (e) {
      console.error('Cart Quick Shop Error:', e);
    }
  }

  /* ── Global click delegation (attached once, survives re-injection) ── */
  document.addEventListener('click', function (e) {
    // 1. Tab Clicks
    var tab = e.target.closest('.cqs-tab');
    if (tab) {
      var widget = tab.closest('.cqs-widget');
      if (!widget) return;
      widget.querySelectorAll('.cqs-tab').forEach(function (t) { t.classList.remove('is-active'); });
      widget.querySelectorAll('.cqs-content').forEach(function (c) { c.classList.remove('is-active'); });
      tab.classList.add('is-active');
      var targetContent = widget.querySelector('#' + tab.dataset.target);
      if (targetContent) targetContent.classList.add('is-active');
      return;
    }

    // 2. Brand Clicks
    var brandBtn = e.target.closest('[data-brand-idx]');
    if (brandBtn) {
      var b = window.CQS_Brands[brandBtn.getAttribute('data-brand-idx')];
      if (b && b.models && b.models.length > 0) {
        window.CQS_NavStack = [{ models: b.models, brandLabel: b.label, brand: b }];
        cqsRenderModels(b.models, b.label);
        document.getElementById('cqs-step-brands').classList.remove('is-active');
        document.getElementById('cqs-step-models').classList.add('is-active');
      } else if (b) {
        cqsGoTo(b.allHandle || b.id);
      }
      return;
    }

    // 3. Model Clicks
    var modelBtn = e.target.closest('[data-model-idx]');
    if (modelBtn) {
      var top = window.CQS_NavStack[window.CQS_NavStack.length - 1];
      if (!top) return;
      var m = top.models[modelBtn.getAttribute('data-model-idx')];
      if (m && m.kids && m.kids.length > 0) {
        window.CQS_NavStack.push({ models: m.kids, brandLabel: m.name, brand: top.brand });
        cqsRenderModels(m.kids, m.name);
      } else if (m) {
        cqsGoTo(m.handle || top.brand.allHandle || top.brand.id);
      }
      return;
    }

    // 4. Back Button
    var backBtn = e.target.closest('#cqs-btn-back');
    if (backBtn) {
      if (window.CQS_NavStack.length > 1) {
        window.CQS_NavStack.pop();
        var prev = window.CQS_NavStack[window.CQS_NavStack.length - 1];
        cqsRenderModels(prev.models, prev.brandLabel);
      } else {
        window.CQS_NavStack = [];
        document.getElementById('cqs-step-models').classList.remove('is-active');
        document.getElementById('cqs-step-brands').classList.add('is-active');
      }
      return;
    }

    // 5. Search Suggestion Clicks
    var sugBtn = e.target.closest('.cqs-sug[data-sug-handle]');
    if (sugBtn) {
      cqsGoTo(sugBtn.getAttribute('data-sug-handle'));
      return;
    }

    // Close dropdown if clicked outside
    var searchWrap = e.target.closest('.cqs-search-wrap');
    if (!searchWrap) {
      var dd = document.getElementById('cqs-dd');
      if (dd) dd.classList.remove('is-open');
    }
  });

  /* ── Global input delegation (search) ── */
  var searchTimer;
  document.addEventListener('input', function (e) {
    if (!e.target.matches('#cqs-search')) return;
    var q = (e.target.value || '').trim().toLowerCase();
    var searchDD = document.getElementById('cqs-dd');
    if (!searchDD) return;
    clearTimeout(searchTimer);

    if (q.length < 2) {
      searchDD.classList.remove('is-open');
      searchDD.innerHTML = '';
      return;
    }

    searchTimer = setTimeout(function () {
      var tokens = q.split(/\s+/).filter(Boolean);
      var hits = [];

      function matchesAll(str) {
        var t = String(str || '').toLowerCase();
        return tokens.every(function (tok) { return t.includes(tok); });
      }

      // Search Brands
      for (var i = 0; i < window.CQS_Brands.length && hits.length < 6; i++) {
        if (matchesAll(window.CQS_Brands[i].label)) {
          hits.push({ type: 'brand', data: window.CQS_Brands[i], name: window.CQS_Brands[i].label, sub: 'Brand' });
        }
      }

      // Search Models
      function dig(arr, brand) {
        for (var k = 0; k < arr.length && hits.length < 6; k++) {
          var m = arr[k];
          var combined = brand.label + ' ' + (m.name || '');
          if (matchesAll(combined)) {
            hits.push({ type: 'model', data: m, brand: brand, name: m.name, sub: brand.label });
          }
          if (m.kids && m.kids.length) dig(m.kids, brand);
        }
      }
      window.CQS_Brands.forEach(function (b) { if (b.models) dig(b.models, b); });

      if (hits.length === 0) {
        searchDD.innerHTML = '<div class="cqs-sug"><div class="cqs-sug-sub">' + (CFG.t_no_results || 'No results for') + ' "' + q + '"</div></div>';
      } else {
        searchDD.innerHTML = hits.map(function (h) {
          var handle = h.type === 'brand' ? (h.data.allHandle || h.data.id) : (h.data.handle || h.brand.allHandle || h.brand.id);
          return '\
            <div class="cqs-sug" data-sug-handle="' + handle + '">\
              <div>\
                <div class="cqs-sug-name">' + h.name + '</div>\
                <div class="cqs-sug-sub">' + h.sub + '</div>\
              </div>\
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:14px;height:14px;color:#94a3b8;"><path d="m9 18 6-6-6-6"/></svg>\
            </div>';
        }).join('');
      }
      searchDD.classList.add('is-open');
    }, 150);
  });

  /* ── Initialise now (if already in DOM) and on DOMContentLoaded ── */
  function boot() { if (document.getElementById('cqs-data-source')) initCQS(); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  /* ── Re-initialise whenever the module is (re)injected via AJAX ──
     Fires when the empty-cart drawer is rebuilt after removing the last item. */
  var reinitTimer;
  var mo = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if (n.id === 'cqs-data-source' || (n.querySelector && n.querySelector('#cqs-data-source'))) {
          clearTimeout(reinitTimer);
          reinitTimer = setTimeout(initCQS, 0);
          return;
        }
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
